import React, { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const DetailTokenReport = () => {
	const { postCall, setGetLoad, getLoad, detailTreport, setDetailTreport, getDate, getBill, setViewBillModal, downloadExcel } = useContext(AppContext);
	const [filename, setFilename] = useState('report_detailed_token.xlsx');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		let service = e.target.service.value;
		if (start !== "" && end !== "") {
			setGetLoad(true)
			postCall('api/bnr/get/detailed/token/report/', { start_date: start, end_date: end, staff_id: staff, service_id: service }).then(res => {
				setDetailTreport(res.data);
				setFilename(`report_detailed_token_${start}_${end}.xlsx`);
				setGetLoad(false);
			}).catch(err => {
				setGetLoad(false);
			});
		}
	}

	const formatExcel = () => {
		if (detailTreport !== undefined && detailTreport.bill_values !== undefined && Object.keys(detailTreport.bill_values).length > 0) {
			let data = [];
			Object.keys(detailTreport.bill_values).map(b_val => {
				const bill = detailTreport.bill_values[b_val];
				let services = "";
				if (bill.bill_services) {
					Object.keys(bill.bill_services).map(s => {
						services += bill.bill_services[s].service_name + ", ";
					})
				}
				data.push({
					'Invoice': bill.bill_no,
					'Date': bill.close_date + ' ' + bill.close_time,
					'Services': services,
					'Created By': bill.token_created_by,
					'Created Time': bill.created_time,
					'Processed By': bill.token_processed_by,
					'Processed Time': bill.open_time,
					'Closed By': bill.token_created_by, // Note: The original code showed 'Closed - token_created_by' in one div and 'Processed' in another. Assuming fields.
					'Closed Time': bill.close_time,
					'Customer': bill.customer_name,
					'Phone': bill.customer_phone,
					'TC': parseFloat(bill.transaction_bill_total).toFixed(2),
					'SC': parseFloat(bill.service_bill_total).toFixed(2),
					'Total': parseFloat(bill.bill_total).toFixed(2)
				});
			});
			return data;
		}
	}

	return (
		<div className='container-fluid'>
			<div className='grid2by8 align-items-center bgp br-3 p-2 mb-2'>
				{
					getLoad ? (
						<div className="d-grid py-2">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						<span>Detailed Token Report</span>
					)
				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									detailTreport !== undefined ? (
										detailTreport.users !== undefined ? (
											Object.keys(detailTreport.users).length > 0 ? (
												Object.keys(detailTreport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{detailTreport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="service" className="shadow-none br-2">
								<option value="" >All services</option>
								{
									detailTreport !== undefined ? (
										detailTreport.services !== undefined ? (
											Object.keys(detailTreport.services).length > 0 ? (
												Object.keys(detailTreport.services).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`serv_${staff_i}`} >{detailTreport.services[staff].name}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={2} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				detailTreport !== undefined && detailTreport.bill_values !== undefined && Object.keys(detailTreport.bill_values).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), filename);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							$('.view-bill-link').addClass('hide');
							generatePDF(tableRef, filename);
							$('.view-bill-link').removeClass('hide');
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
							onBeforeGetContent={() => {
								return new Promise((resolve) => {
									$('.view-bill-link').addClass('hide');
									resolve();
								});
							}}
							onAfterPrint={() => {
								$('.view-bill-link').removeClass('hide');
							}}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				<Table bordered className="tbl-bg-blue" >
					<thead>
						<tr>
							<th><span className="tp2" >Invoice</span></th>
							<th className="tp2" ><span>Service</span></th>
							<th className="tp2" ><span>Times</span></th>
							<th className="tp2" >Staff</th>
							<th className="tp2" ><span>Customer</span></th>
							<th className="text-end tp2" ><span>SC</span></th>
							<th className="text-end tp2" ><span>TC</span></th>
							<th className="text-end tp2" >Total</th>
						</tr>
					</thead>
					<tbody>
						{
							detailTreport !== undefined ? (
								detailTreport.bill_values !== undefined ? (
									Object.keys(detailTreport.bill_values).length > 0 ? (
										Object.keys(detailTreport.bill_values).map((b_val, b_i) => (
											<tr key={`b_val_${b_i}`} >
												<td>
													<span className="tp2 d-grid mb-1" >Invoice : {detailTreport.bill_values[b_val].bill_no}</span>
													<span onClick={() => {
														getBill(detailTreport.bill_values[b_val].bill_no);
														setViewBillModal(true);
													}} className="view-bill-link mx-0" >View bill</span>
													<span className="tp2 f14 d-grid mt-1" >{detailTreport.bill_values[b_val].close_date}, {detailTreport.bill_values[b_val].close_time}</span>
												</td>
												<td>
													{
														detailTreport.bill_values[b_val].bill_services !== undefined ? (
															Object.keys(detailTreport.bill_values[b_val].bill_services).length > 0 ? (
																Object.keys(detailTreport.bill_values[b_val].bill_services).map((bserv, bs_i) => (
																	<span className="tp2 d-grid mb-1" key={`bserv_${bs_i}`}  >{detailTreport.bill_values[b_val].bill_services[bserv].service_name}</span>
																))
															) : ''
														) : ''
													}
												</td>
												<td>
													<div class="grid8by2 align-items-center bdrb2" >
														<span className="tp2 f14" >{`Created - ${detailTreport.bill_values[b_val].token_created_by}`}</span>
														<div className='d-flex justify-content-end'>
															<span className="tp2 f14" >{detailTreport.bill_values[b_val].created_time}</span>
														</div>
													</div>
													<div class="grid8by2 align-items-center bdrb2" >
														<span className="tp2 f14" >{`Processed - ${detailTreport.bill_values[b_val].token_processed_by}`}</span>
														<div className='d-flex justify-content-end'>
															<span className="tp2 f14" >{detailTreport.bill_values[b_val].open_time}</span>
														</div>
													</div>
													<div class="grid8by2 align-items-center bdrb2" >
														<span className="tp2 f14" >{`Closed - ${detailTreport.bill_values[b_val].token_created_by}`}</span>
														<div className='d-flex justify-content-end'>
															<span className="tp2 f14" >{detailTreport.bill_values[b_val].close_time}</span>
														</div>
													</div>
												</td>
												<td>
													<span className="tp2 d-grid mb-1" >{detailTreport.bill_values[b_val].token_processed_by}</span>
												</td>
												<td>
													<span className="tp2 d-grid mb-1" >{detailTreport.bill_values[b_val].customer_name}</span>
													<span className="tp2 d-grid mb-1" >{detailTreport.bill_values[b_val].customer_phone}</span>
												</td>
												<td className="tp2 text-end" >
													<span>{parseFloat(detailTreport.bill_values[b_val].transaction_bill_total).toFixed(2)}</span>
												</td>
												<td className="tp2 text-end" >
													<span>{parseFloat(detailTreport.bill_values[b_val].service_bill_total).toFixed(2)}</span>
												</td>
												<td className="tp2 text-end" >
													<span>{parseFloat(detailTreport.bill_values[b_val].bill_total).toFixed(2)}</span>
												</td>
											</tr>
										))
									) : ''
								) : ''
							) : ''
						}
						{
							detailTreport !== undefined ? (
								detailTreport.main !== undefined ? (
									<tr>
										<td colSpan={5} className="text-end bgy" ><span className="f20" >Total</span></td>
										<td className="text-end bgy" ><span className="f20" >{parseFloat(detailTreport.main.transaction_day_total).toFixed(2)}</span></td>
										<td className="text-end bgy" ><span className="f20" >{parseFloat(detailTreport.main.service_day_total).toFixed(2)}</span></td>
										<td className="text-end bgy" ><span className="f20" >{parseFloat(detailTreport.main.grand_day_total).toFixed(2)}</span></td>
									</tr>
								) : ''
							) : ''
						}
					</tbody>
				</Table>
			</div>
		</div>
	)
}